import { inject, Injectable } from '@angular/core';
import { Title } from '@angular/platform-browser';
import { RouterStateSnapshot, TitleStrategy } from '@angular/router';

import { TranslateService } from '@ngx-translate/core';

@Injectable({ providedIn: 'root' })
export class LocalizedTitleStrategy extends TitleStrategy {
  private translate = inject(TranslateService);
  private title = inject(Title);

  override updateTitle(routerState: RouterStateSnapshot) {
    let route = routerState.root;
    const titles: string[] = [];

    while (route.firstChild) {
      route = route.firstChild;
      const title = route.title;
      if (title) titles.push(title);
    }

    if (titles.length > 0) {
      this.translate.get(titles.join('.')).subscribe(translated => {
        this.title.setTitle(`${translated}`);
      });
    }
  }
}
